//  Testing constants
export const inputLabelTestId = 'text-input-label';
export const inputSublabelTestId = 'text-input-sublabel';
export const loadingSkeletonTestId = 'skeleton';
export const passwordIconTestId = 'password-input-addornment';
export const customAdornmentTestId = 'addornment-test-id';
export const errorIconTestId = 'error-addornment';
export const testPropsTestId = 'test_id';
